import { render, staticRenderFns } from "./NewDocumentIcon.vue?vue&type=template&id=382b31e4"
import script from "./NewDocumentIcon.vue?vue&type=script&lang=ts"
export * from "./NewDocumentIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports